import React from 'react';
import { useParams } from 'react-router';
import CommunityEventCard from 'components/community/CommunityEventCard';
import { EventCourse } from 'services/graphqltypes';
import { useIntl } from 'react-intl';
import useLoadCommunityActivities from 'hooks/useLoadCommunityActivities';

const EmbeddableCommunityEvents = (): React.ReactElement => {
  const { communitySlug, count } = useParams() as any;
  const intl = useIntl();

  const { loading, error, activities } =
    useLoadCommunityActivities({
      communitySlug: communitySlug,
      timeScope: 'upcoming',
      state: 'published',
      type: 'all',
      orderBy: 'START_TIME_ASC',
      count: parseInt(count),
    });

  if (loading) return <div className="loading"> </div>;
  if (error) return <h2>{`ARK had a problem loading data: ${error.message}`}</h2>;

  return (
    <div className="mt-3 bg-transparent">
      {
        (activities?.length !== 0)
          ? activities?.map((communityEvent: EventCourse, id: number) => (
            <CommunityEventCard event={communityEvent} communitySlug={communitySlug} id={id} key={id} forEmbeddable/>
          ))
          :
          <div className="d-flex mx-auto justify-content-center mb-3">
            <div className="font-weight-bold h4">
              {intl.formatMessage({ id: 'general.no-upcoming-activities' })}
            </div>
          </div>
      }
    </div>
  );
};

export default EmbeddableCommunityEvents;
